import {Component, Input} from '@angular/core';
import {SwiperOptions} from 'swiper/types';
import {CurrentUserViewModel} from '../../../../../core/models/current-user.view-model';
import {ReactionListItemInterface} from '../../../../../core/interfaces/reaction-list-item.interface';
import {SocialDataProviderService} from '../../../../timeline/social-grid-list/social-data-provider.service';
import {SocialListItemRenderer} from '../social-list-item-renderer.interface';
import {UserViewModel} from '../../../../../features/user/settings/user.view-model';

@Component({
  selector: 'app-reaction-list-item',
  templateUrl: './reaction-list-item.component.html'
})
export class ReactionListItemComponent implements SocialListItemRenderer<ReactionListItemInterface> {
  @Input() public item: ReactionListItemInterface;
  @Input() public currentUser: CurrentUserViewModel;
  @Input() public socialDPS: SocialDataProviderService;
  @Input() public navigateTo: (item: ReactionListItemInterface) => void;
  @Input() public swiperConfig: SwiperOptions;
  @Input() public rendererInputs?: Record<string, unknown>;

  get showReactionIntent(): boolean {
    return !!this.rendererInputs?.showReactionIntent;
  }

  public isFollowedByCurrentUser(): boolean {
    return this.socialDPS.isFollowedByCurrentUser(this.item.author as unknown as UserViewModel);
  }

  public isLikedByCurrentUser(): boolean {
    return this.socialDPS.isLikedByCurrentUser(this.item.author as unknown as UserViewModel);
  }
}
